import React from 'react';

import ConfigurationListPage from './components/ConfigurationListPage/ConfigurationListPage';

export default props => (
  <ConfigurationListPage recordsPerPage={10} {...props} />
);
